import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { Receipt } from 'ts/types/Receipt'
import ReceiptCardTable from 'components/ReceiptCardTable'
import ReceiptAddPage from './ReceiptAddPage'
import { useTrader } from 'context/TraderTypeContext';

const ReceiptPage = () => {
  const Url = GetUrls();
  const { traderId } = useTrader();

const columns: Column<Receipt>[] = [
  {
    Header: 'Date',
    accessor: 'transactionDate',
    minWidth: 90,
    maxWidth: 90,
    Cell: ({ value }) => {
      const date = new Date(value);
      const day = date.getUTCDate().toString().padStart(2, '0');
      const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
      const year = date.getUTCFullYear().toString().slice(-2);
      const hours = date.getUTCHours();
      const minutes = date.getUTCMinutes().toString().padStart(2, '0');
      const displayHours = (hours % 12 || 12).toString().padStart(2, '0');
      
      return `${day}/${month}/${year} ${displayHours}:${minutes} ${hours >= 12 ? 'pm' : 'am'}`;
    }
  },
  {
    Header: 'Trans. No',
    accessor: 'transactionNo',
    minWidth: 130,
    maxWidth: 130,
    Cell: ({ value }) => (
      <div className="font-medium">{value}</div>
    )
  },
  {
    Header: 'Trace No',
    accessor: 'traceNo',
    minWidth: 80,
    maxWidth: 80
  },
  {
    Header: 'Operator',
    accessor: 'operatorName',
    minWidth: 100,
    maxWidth: 100,
    Cell: ({ value, row }) => (
      <div title={value || ''}>
        {value || `ID: ${row.original.operatorId}`}
      </div>
    )
  },
  {
    Header: () => <div style={{ textAlign: 'right' }}>Amount</div>,
    accessor: 'amount',
    minWidth: 90,
    maxWidth: 90,
    Cell: ({ value }) => (
      <div style={{ textAlign: 'right' }} className="font-medium">
        ${value.toFixed(2)}
      </div>
    )
  },
  {
    Header: "",
    accessor: 'receipt',
    minWidth: 0,
    maxWidth: 0,
    Cell: ""
  },
]

  return (
    <ReceiptCardTable
      columns={columns}
      dataKey={Url.getReceipt.toString()}
      url={Url.getReceipt(`traderId=${traderId}`)}  
      modalChild={<ReceiptAddPage />}
    />
  )
}

export default ReceiptPage
